// Cesium Viewer translations
// These translations are merged into the main i18n configuration

import { tipsTranslations } from '../tips/locale';

export const viewerTranslations = {
  en: {
    ...tipsTranslations.en,
    Controls: "Controls",
    PointCloudSettings: "Point Cloud Settings",
    PointSize: "Point Size",
    PointOpacity: "Point Opacity",
    EyeDomeLighting: "Eye-Dome Lighting",
    EDLStrength: "EDL Strength",
    EDLRadius: "EDL Radius",
    WorldSettings: "World Settings",
    GlobeLighting: "Globe Lighting",
    Atmosphere: "Atmosphere",
    TerrainSettings: "Terrain Settings",
    Terrain: "Terrain",
    ContourLines: "Contour Lines",
    ContourSpacing: "Contour Spacing",
    ThickLineInterval: "Thick Line Interval",
    LineThickness: "Line Thickness",
    Camera: "Camera",
    RecenterCamera: "Recenter Camera",
    RecenterCameraTooltip: "Recenter camera on point cloud",
    FieldOfView: "Field of View",
    ZoomSpeed: "Zoom Speed",
    MeasurementTools: "Measurement Tools",
    // Profiler
    Profiler: "Profiler",
    CreateProfile: "Create a new profile",
    Profiles: "Profiles",
    Start: "Start",
    Stop: "Stop",
    Width: "Width",
    HorizontalSection: "West/East Section",
    VerticalSection: "North/South Section",
    SelectTwoPointsToCreateProfile: "Select 2 points to create a profile",
    ProfileView: "Profile View",
    DistanceMeasurementTooltip: "Distance Measurement (2 points)",
    HeightMeasurementTooltip: "Height Measurement (point to ground)",
    AngleMeasurementTooltip: "Angular Measurement (3 points)",
    AreaMeasurementTooltip: "Surface Area Measurement (left-click to add points, right-click to close polygon)",
    CircleMeasurementTooltip: "Circle Measurement (3 points defining the circle)",
    ImportMeasurementsTooltip: "Import measurements from JSON",
    ClearAllMeasurementsTooltip: "Clear All Measurements",
    ExportMeasurementsTooltip: "Export measurements to JSON",
    DeleteMeasurementTooltip: "Delete measurement",
    // Property visualization
    Property: "Property",
    Color: "Color",
    Intensity: "Intensity",
    IntensityRange: "Intensity Range",
    Elevation: "Elevation",
    ElevationRange: "Elevation Range",
    Distance: "Distance",
    "Distance Range": "Distance Range",
    Classification: "Classification",
    ClassificationFilter: "Classes",
    AllClasses: "All classes",
    "Return Numbers": "Return Numbers",
    "Number of Returns": "Number of Returns",
    // Classification labels
    Unclassified: "Unclassified",
    Ground: "Ground",
    "Low Vegetation": "Low Vegetation",
    "Medium Vegetation": "Medium Vegetation",
    "High Vegetation": "High Vegetation",
    Building: "Building",
    "Low Point": "Low Point",
    "Model Key-point": "Model Key-point",
    Water: "Water",
    Rail: "Rail",
    "Road Surface": "Road Surface",
    "Overlap Points": "Overlap Points",
    "Wire - Guard": "Wire - Guard",
    "Wire - Conductor": "Wire - Conductor",
    "Transmission Tower": "Transmission Tower",
    "Wire-Structure Connector": "Wire-Structure Connector",
    "Bridge Deck": "Bridge Deck",
    "High Noise": "High Noise",
    // Return number labels
    "First Return": "First Return",
    "Second Return": "Second Return",
    "Third Return": "Third Return",
    "Fourth Return": "Fourth Return",
    "Fifth Return": "Fifth Return",
    "Sixth+ Return": "Sixth+ Return",
    "Fourth+ Return": "Fourth+ Return",
    // Number of returns labels
    "Single Return": "Single Return",
    "Two Returns": "Two Returns",
    "Three Returns": "Three Returns",
    "Four Returns": "Four Returns",
    "Five Returns": "Five Returns",
    "Six+ Returns": "Six+ Returns",
    "Four+ Returns": "Four+ Returns",
    DistanceInstructions: "Click on 2 points to measure a distance",
    HeightInstructions: "Click on a point to measure its height above ground",
    AngleInstructions: "Click on 3 points: first point, vertex, last point",
    AreaInstructions: "Left-click to add points, right-click to close polygon (minimum 3 points)",
    CircleInstructions: "Click on 3 points to define a circle",
    PointsSelected: "Points selected",
    ClickSecondPoint: " (Click on the 2nd point)",
    ClickThirdPoint: " (Click on the 3rd point)",
    Height: "Height",
    Angle: "Angle",
    Area: "Area",
    Circle: "Circle",
    "Forest report": "Forest report",
    TreeId: "Tree",
    TreeLon: "Lon",
    TreeLat: "Lat",
    TreeElevation: "Z",
    TreeRadius: "Radius",
    TreeHeight: "Height",
    Comment: "Comment",
    Species: "Species",
    Cedar: "Cedar",
    Pine: "Pine",
    Measurements: "Measurements",
    ShareView: "Share view",
    // Share Link Dialog translations
    GenerateShareLink: "Share view",
    ShareLinkDescription: "Create a temporary share link that allows others to view this point cloud without needing to register or log in.",
    LinkExpiration: "Link Expiration",
    OneDayExpiration: "1 day",
    ThreeDaysExpiration: "3 days",
    OneWeekExpiration: "1 week",
    TwoWeeksExpiration: "2 weeks",
    OneMonthExpiration: "1 month",
    ClickGenerateLinkInfo: "Click \"Generate Link\" to create a shareable URL for this dataset.",
    GeneratingShareLink: "Generating share link...",
    ShareLinkExpiresIn: "Share Link (expires in {{expiration}}):",
    LinkCopiedToClipboard: "Link copied to clipboard!",
    FailedToCopyLink: "Failed to copy link",
    Copied: "Copied!",
    CopyToClipboard: "Copy to clipboard",
    Important: "Important",
    ShareLinkWarning: "This link will expire automatically after the selected time period. The recipient will be able to view the point cloud but not download or modify it.",
    GenerateLink: "Generate Link",
    GenerateNewLink: "Generate New Link",
    // Short URL Resolver translations
    InvalidShortCode: "Invalid short code",
    ResolvingShortUrl: "Resolving short URL...",
    RedirectingPleaseWait: "Redirecting, please wait...",
    FileDownloadStarted: "Download Started",
    FileDownloadDescription: "Your file download should begin shortly.",
    ShortUrlNotFound: "Short URL not found or has expired",
    ShortUrlError: "Short URL Error",
    ShortUrlErrorDescription: "The short URL you requested could not be found or has expired.",
    CreatingShortLink: "Creating short link...",
    UsingLocalFallback: "Using local storage fallback - link may not work on other devices",
    ShorteningFailed: "URL shortening failed, using original URL",
    ShorteningError: "Failed to shorten URL, using original",
    LoadingViewer: "Loading Viewer",
    ViewerDescription: "Opening the point cloud viewer. You will be redirected shortly to view the 3D data.",
    ShareLinkCesiumWarning: "This link will not expire and needs to be deleted manually. The recipient will be able to view the point cloud but not download or modify it.",
    CreateShareLink: "Create a new viewer link",
    ShareLink: "Viewer link",
    ExistingShareLink: "Link available",
    DeleteShareLink: "Delete the link",
    ExistingShareLinkInfo: "test",
    NoShareLinkExists: "No link available for this file, please generate a new link.",
    CreateNewLink: "Create a new link",
    CreatingShareLink: "The link is being created, please wait.",
    ShareLinkCreatedSuccessfully: "The link has been created.",
    ShareLinkDeletedSuccessfully: "The link has been deleted.",
    LinkUsage: "Link usage",
    Remaining: "Remaining",
    NoRemainingLinks: "You have reached your link creation limit. Please delete an existing link before creating a new one.",
    // Gaussian Splatting and View Mode translations
    GaussianSplatting: "Gaussian Splatting",
    View: "View",
    FullScreen: "Full Screen",
    SplitScreen: "Split Screen",
    PointCloud: "Point Cloud",
    Photos: "Photos (for Gaussian Splatting)",
    SettingsCesium: "Settings",
    ExitViewer: "Close the viewer",
    // Viewpoints translations
    Viewpoints: "Viewpoints",
    SaveCurrentViewpoint: "Save Current Viewpoint",
    RestoreViewpoint: "Restore Viewpoint",
    DeleteViewpoint: "Delete Viewpoint",
    ExportViewpoints: "Export Viewpoints",
    ImportViewpoints: "Import Viewpoints",
    ClearAllViewpoints: "Clear All Viewpoints",
    SavedViewpoints: "Saved Viewpoints",
    NoViewpointsSaved: "No viewpoints saved yet",
    UploadToCesiumION: "Upload to Cesium ION",
    Longitude: "Longitude",
    Latitude: "Latitude",
    ErrorCoordinatesRequired: "Longitude, Latitude, and Height are required when uploading to Cesium ION",
    // Thank You Page translations
    ThankYouTitle: "Thank you for using Mirukuru-Online",
    ThankYouMessage: "We hope you enjoyed exploring the 3D visualization.",
    SessionEnded: "Your session has ended successfully.",
    GoToHomepage: "Go to Homepage",
    MirukuruTagline: "Mirukuru-Online - Advanced 3D Data Visualization Platform",
    // Public Cesium Viewer translations
    LoadingSharedView: "Loading shared view...",
    UnableToLoadSharedView: "Unable to load shared view",
    SharedLinkExpiredMessage: "This shared link may have expired or is invalid. Please contact the person who shared this link for a new one.",
    SharedLinkSecurityNote: "Shared links have expiration dates for security purposes.",
    // BaseLayer Panel translations
    BaseLayers: "Base Layers",
    ImageryLayers: "Imagery Layers",
    TerrainLayers: "Terrain Layers",
    BuildingLayers: "Building Layers",
    GlobalLayer: "Global Layer",
    GlobalLayerGoogleTiles: "Google's Photorealistic 3D Tiles",
    BuildingLayersNone: "None",
    BuildingLayersOSM: "Cesium OSM Buildings",
    BuildingLayersJapan3D: "Japan 3D (Plateau)",
    // Clipping tools
    ClippingPlanes: "Clipping Planes",
    Clipping: "Clipping",
    EnableClipping: "Enable clipping",
    DisableClipping: "Disable clipping",
    ResetClippingPlanes: "Reset clipping planes",
    ClippingActiveDragPlanes: "Drag planes to move them.",
    ClippingInactiveTip: "Enable clipping to add draggable planes.",
    // Compass Widget and Zoom Controls translations
    CompassDragTooltip: "Drag to rotate • Double-click to reset",
    CompassJoystickTooltip: "Drag like a joystick • Further = Faster • Release to stop",
    ZoomIn: "Zoom In",
    ZoomOut: "Zoom Out",
    TopView: "Top View",
    BottomView: "Bottom View",
    NorthView: "North view",
    SouthView: "South view",
    EastView: "East view",
    WestView: "West view",
    Rendering: "Rendering",
    VisualFidelity: "Visual Fidelity",
    HighFidelity: "Quality",
    Balanced: "Balanced",
    HighPerformance: "Performance",
    ReducePixelDensity: "Reduce pixel density",
    RotateHint: "Left-drag this cylinder to adjust its position. Right-drag it to adjust its orientation.",
    IncreaseRadius: "Increase",
    DecreaseRadius: "Decrease",
    Done: "Done",
    Track: "Track",
    StopTracking: "Stop tracking",
    // Status bar
    StatusBarNoTool: "No active tool",
    StatusBarActiveTool: "Active Tool",
    // Toolbar tooltip descriptions
    ToolbarMeasurementDesc: "Distance, height, angle, area",
    ToolbarProfilerDesc: "Cross-section profiles",
    ToolbarClippingDesc: "Clip point cloud with planes",
    ToolbarGaussianDesc: "Gaussian Splatting view modes",
    ToolbarModelsDesc: "3D models and products",
    ToolbarViewpointsDesc: "Save and restore camera views",
    ToolbarLayersDesc: "Imagery, terrain, buildings",
    ToolbarSettingsDesc: "Point cloud and rendering settings",
    TransformationTool: "Transformation",
    ToolbarTransformationDesc: "Adjust position, rotation and scale",
    SaveTransformation: "Save transformation",
    TransformationSaved: "Transformation saved",
    TransformationSaveFailed: "Failed to save transformation",
    RestoreDefault: "Restore default",
    Translation: "Translation",
    Rotation: "Rotation",
    Scale: "Scale",
    BothDatasets: "Both",
    Dataset: "Dataset",
    // Toolbar groups
    ToolbarGroupAnalysis: "Analysis",
    ToolbarGroupVisualization: "Visualization",
    ToolbarGroupSystem: "System",
    // Panel pinning
    PinPanel: "Pin panel",
    UnpinPanel: "Unpin panel",
    // Color legend
    ShowLegend: "Show legend",
    HideLegend: "Hide legend",
    // Toast messages
    MeasurementExported: "Measurements exported",
    NoMeasurementsToExport: "No measurements to export",
    MeasurementsImported: "Measurements imported",
    MeasurementImportError: "Failed to import measurements",
    ViewpointSaved: "Viewpoint saved",
    ViewpointRestored: "Viewpoint restored",
    ViewpointsExported: "Viewpoints exported",
    ViewpointsImported: "Viewpoints imported",
    Camera: "Camera",
    Annotations: "Annotations",
    PlaceAnnotation: "Place Annotation",
    ExportAnnotations: "Export Annotations",
    ImportAnnotations: "Import Annotations",
    ClearAllAnnotations: "Clear All Annotations",
    SavedAnnotations: "Saved Annotations",
    AnnotationPlaced: "Annotation placed",
    AnnotationsExported: "Annotations exported",
    AnnotationsImported: "Annotations imported",
    ToolbarAnnotationsDesc: "Pin text labels to locations",
    EnterAnnotationText: "Enter annotation text:",
    ClippingPlanesReset: "Clipping planes reset",
    Minimap: 'Minimap',
    ToggleMinimapDesc: 'Toggle overview map',
    Close: 'Close',
    // B4 – SSAO
    AmbientOcclusion: 'Ambient Occlusion',
    AmbientOcclusionIntensity: 'AO Intensity',
    FXAA: 'Anti-aliasing (FXAA)',
    // A – Walk Mode
    WalkMode: 'Walk Mode',
    WalkModeHint: 'WASD to move · ESC to exit',
    // Loading screen hints
    LoadingHint0: 'Initializing the viewer...',
    LoadingHint1: 'Loading terrain...',
    LoadingHint2: 'Loading the dataset...',
    LoadingHint3: 'Preparing the point cloud...',
    LoadingHint4: 'Almost ready...',
    // Colormap palette switcher
    ColorScale: 'Color Scale',
    ColormapTurbo: 'Turbo',
    ColormapViridis: 'Viridis',
    ColormapMagma: 'Magma',
    ColormapInferno: 'Inferno',
    ColormapCividis: 'Cividis',
    ColormapGrayscale: 'Grayscale',
    // Coordinate format
    CoordFormatTooltip: 'Click to change format (DD / DMS / UTM)',
    // Status bar / Statistics panel
    StatsTooltip: 'Statistics',
    StatsPerformance: 'Performance',
    StatsPing: 'Ping',
    StatsTiles: 'Tiles',
    StatsPending: 'Pending',
    StatsProcessing: 'Processing',
    StatsLoaded: 'Loaded',
    StatsRendered: 'Rendered',
    StatsFailed: 'Failed',
    StatsData: 'Data',
    StatsPointsInTiles: 'Points in rendered tiles',
    StatsPointsInMemory: 'Points in memory',
    StatsGaussianSplats: 'Gaussian splats',
    StatsTriangles: 'Triangles',
    StatsMemory: 'GPU Memory',
    StatsTotal: 'Total',
    StatsGeometry: 'Geometry',
    StatsTextures: 'Textures',
    StatsMetadata: 'Metadata',
  },
  jp: {
    ...tipsTranslations.jp,
    Controls: "コントロール",
    PointCloudSettings: "点群設定",
    PointSize: "点のサイズ",
    PointOpacity: "点の透明度",
    EyeDomeLighting: "アイドームライティング (EDL)",
    EDLStrength: "EDL強度",
    EDLRadius: "EDL半径",
    WorldSettings: "ワールド設定",
    GlobeLighting: "グローブライティング",
    Atmosphere: "大気",
    TerrainSettings: "地形設定",
    Terrain: "地形",
    ContourLines: "等高線",
    ContourSpacing: "等高線間隔",
    ThickLineInterval: "太線間隔",
    LineThickness: "線の太さ",
    Camera: "カメラ",
    RecenterCamera: "カメラを中央に",
    RecenterCameraTooltip: "点群にカメラを中央配置",
    FieldOfView: "視野角",
    ZoomSpeed: "ズーム速度",
    MeasurementTools: "測定ツール",
    // Profiler
    Profiler: "プロファイラー",
    CreateProfile: "新しいプロフィールを作成する",
    Profiles: "プロファイル",
    Start: "開始",
    Stop: "停止",
    Width: "幅",
    HorizontalSection: "東西断面",
    VerticalSection: "南北断面",
    SelectTwoPointsToCreateProfile: "2点を選択してプロファイルを作成",
    ProfileView: "プロファイルビュー",
    DistanceMeasurementTooltip: "距離測定（2点）",
    HeightMeasurementTooltip: "高度測定（地面からの点）",
    AngleMeasurementTooltip: "角度測定（3点）",
    AreaMeasurementTooltip: "面積測定（左クリックで点を追加、右クリックでポリゴンを閉じる）",
    CircleMeasurementTooltip: "円測定（円を定義する3点）",
    ImportMeasurementsTooltip: "JSONから測定値をインポート",
    ClearAllMeasurementsTooltip: "すべての測定をクリア",
    ExportMeasurementsTooltip: "測定値をJSONにエクスポート",
    DeleteMeasurementTooltip: "測定を削除",
    // Property visualization
    Property: "プロパティ",
    Color: "色",
    Intensity: "強度",
    IntensityRange: "強度範囲",
    Elevation: "標高",
    ElevationRange: "標高範囲",
    Distance: "距離",
    "Distance Range": "距離範囲",
    Classification: "クラス",
    ClassificationFilter: "クラス",
    AllClasses: "すべてのクラス",
    "Return Numbers": "リターン番号",
    "Number of Returns": "リターン回数",
    // Classification labels
    Unclassified: "未分類",
    Ground: "地面",
    "Low Vegetation": "低植生",
    "Medium Vegetation": "中植生",
    "High Vegetation": "高植生",
    Building: "建物",
    "Low Point": "低点",
    "Model Key-point": "モデルキーポイント",
    Water: "水域",
    Rail: "線路",
    "Road Surface": "道路面",
    "Overlap Points": "重複点",
    "Wire - Guard": "ワイヤー - ガード",
    "Wire - Conductor": "ワイヤー - 導体",
    "Transmission Tower": "送電塔",
    "Wire-Structure Connector": "ワイヤー構造コネクタ",
    "Bridge Deck": "橋梁デッキ",
    "High Noise": "高ノイズ",
    // Return number labels
    "First Return": "第1リターン",
    "Second Return": "第2リターン",
    "Third Return": "第3リターン",
    "Fourth Return": "第4リターン",
    "Fifth Return": "第5リターン",
    "Sixth+ Return": "第6+リターン",
    "Fourth+ Return": "第4+リターン",
    // Number of returns labels
    "Single Return": "単一リターン",
    "Two Returns": "2回リターン",
    "Three Returns": "3回リターン",
    "Four Returns": "4回リターン",
    "Five Returns": "5回リターン",
    "Six+ Returns": "6+回リターン",
    "Four+ Returns": "4+回リターン",
    DistanceInstructions: "距離を測定する2つの点をクリックしてください",
    HeightInstructions: "地上からの高さを測定する点をクリックしてください",
    AngleInstructions: "3つの点をクリック：始点、頂点、終点",
    AreaInstructions: "左クリックで点を追加、右クリックでポリゴンを閉じる（最低3点）",
    CircleInstructions: "円を定義する3つの点をクリックしてください",
    PointsSelected: "選択された点",
    ClickSecondPoint: "（2番目の点をクリック）",
    ClickThirdPoint: "（3番目の点をクリック）",
    Height: "高度",
    Angle: "角度",
    Area: "面積",
    Circle: "円",
    "Forest report": "森林レポート",
    TreeId: "樹木",
    TreeLon: "経度",
    TreeLat: "緯度",
    TreeElevation: "標高",
    TreeRadius: "半径",
    TreeHeight: "高さ",
    Comment: "コメント",
    Species: "樹種",
    Cedar: "杉",
    Pine: "松",
    Measurements: "測定値",
    ShareView: "シェアビュー",
    // Share Link Dialog translations
    GenerateShareLink: "シェアビュー",
    ShareLinkDescription: "他の人が登録やログインをせずにこの点群を表示できる一時的な共有リンクを作成します。",
    LinkExpiration: "リンクの有効期限",
    OneDayExpiration: "1日",
    ThreeDaysExpiration: "3日",
    OneWeekExpiration: "1週間",
    TwoWeeksExpiration: "2週間",
    OneMonthExpiration: "1ヶ月",
    ClickGenerateLinkInfo: "「リンクを生成」をクリックして、このデータセットの共有可能なURLを作成します。",
    GeneratingShareLink: "共有リンクを生成中...",
    ShareLinkExpiresIn: "共有リンク（有効期限：{{expiration}}）：",
    LinkCopiedToClipboard: "リンクがクリップボードにコピーされました！",
    FailedToCopyLink: "リンクのコピーに失敗しました",
    Copied: "コピー完了！",
    CopyToClipboard: "クリップボードにコピー",
    Important: "重要",
    ShareLinkWarning: "このリンクは選択した期間後に自動的に期限切れになります。受信者は点群を表示できますが、ダウンロードや変更はできません。",
    GenerateLink: "リンクを生成",
    GenerateNewLink: "新しいリンクを生成",
    // Short URL Resolver translations
    InvalidShortCode: "無効な短縮コード",
    ResolvingShortUrl: "短縮URLを解決中...",
    RedirectingPleaseWait: "リダイレクト中、お待ちください...",
    FileDownloadStarted: "ダウンロード開始",
    FileDownloadDescription: "ファイルのダウンロードがまもなく開始されます。",
    ShortUrlNotFound: "短縮URLが見つからないか、期限切れです",
    ShortUrlError: "短縮URLエラー",
    ShortUrlErrorDescription: "お探しの短縮URLが見つからないか、期限切れです。",
    CreatingShortLink: "短縮リンクを作成中...",
    UsingLocalFallback: "ローカルストレージのフォールバックを使用 - 他のデバイスでは動作しない可能性があります",
    ShorteningFailed: "URL短縮に失敗、元のURLを使用",
    ShorteningError: "URL短縮に失敗、元のURLを使用",
    LoadingViewer: "ビューアーを読み込み中",
    ViewerDescription: "点群ビューアーを開いています。まもなく3Dデータを表示するためにリダイレクトされます。",
    ShareLinkCesiumWarning: "このリンクは期限切れになることはなく、手動で削除する必要があります。受信者は点群を表示できますが、ダウンロードや変更はできません。",
    CreateShareLink: "新しいビューアーリンクを作成",
    ShareLink: "ビューアーリンク",
    ExistingShareLink: "リンクが利用可能",
    DeleteShareLink: "リンクを削除",
    ExistingShareLinkInfo: "テスト",
    NoShareLinkExists: "このファイルにはリンクが利用できません。新しいリンクを生成してください。",
    CreateNewLink: "新しいリンクを作成",
    CreatingShareLink: "リンクを作成中です。お待ちください。",
    ShareLinkCreatedSuccessfully: "リンクが作成されました。",
    ShareLinkDeletedSuccessfully: "リンクは削除された。",
    LinkUsage: "リンク使用状況",
    Remaining: "残り",
    NoRemainingLinks: "リンク作成の上限に達しました。新しいリンクを作成する前に、既存のリンクを削除してください。",
    // Gaussian Splatting and View Mode translations
    GaussianSplatting: "ガウシアンスプラッティング",
    View: "表示",
    FullScreen: "フルスクリーン",
    SplitScreen: "分割スクリーン",
    PointCloud: "点群",
    Photos: "写真 (ガウシアン・スプラッティング)",
    SettingsCesium: "設定",
    ExitViewer: "終了ビューアー",
    // Viewpoints translations
    Viewpoints: "ビューポイント",
    SaveCurrentViewpoint: "現在のビューポイントを保存",
    RestoreViewpoint: "ビューポイントを復元",
    DeleteViewpoint: "ビューポイントを削除",
    ExportViewpoints: "ビューポイントをエクスポート",
    ImportViewpoints: "ビューポイントをインポート",
    ClearAllViewpoints: "すべてのビューポイントをクリア",
    SavedViewpoints: "保存されたビューポイント",
    NoViewpointsSaved: "まだビューポイントが保存されていません",
    UploadToCesiumION: "Cesium IONにもアップロード",
    Longitude: "経度",
    Latitude: "緯度",
    ErrorCoordinatesRequired: "Cesium IONにアップロードする際は、経度、緯度、高さが必要です",
    // Thank You Page translations
    ThankYouTitle: "Mirukuru-Online をご利用いただき、",
    ThankYouTitle2: "ありがとうございました",
    ThankYouMessage: "3D可視化をお楽しみいただけましたでしょうか。",
    SessionEnded: "セッションが正常に終了いたしました。",
    GoToHomepage: "ホームページに戻る",
    MirukuruTagline: "Mirukuru-Online - 高度な3Dデータ可視化プラットフォーム",
    // Public Cesium Viewer translations
    LoadingSharedView: "共有ビューを読み込み中...",
    UnableToLoadSharedView: "共有ビューを読み込めません",
    SharedLinkExpiredMessage: "この共有リンクは期限切れまたは無効の可能性があります。新しいリンクについては、共有者にお問い合わせください。",
    SharedLinkSecurityNote: "共有リンクはセキュリティ上の理由により有効期限があります。",
    // BaseLayer Panel translations
    BaseLayers: "ベースレイヤー",
    ImageryLayers: "画像レイヤー",
    TerrainLayers: "地形レイヤー",
    BuildingLayers: "建物レイヤー",
    GlobalLayer: "グローバルレイヤー",
    GlobalLayerGoogleTiles: "Photorealistic 3D Tiles (Google)",
    BuildingLayersNone: "なし",
    BuildingLayersOSM: "Cesium OSM buldings",
    BuildingLayersJapan3D: "Japan 3D (Plateau)",
    // Clipping tools
    ClippingPlanes: "クリッピング",
    Clipping: "クリッピング",
    EnableClipping: "クリッピングを有効化",
    DisableClipping: "クリッピングを無効化",
    ResetClippingPlanes: "クリッピング面をリセット",
    ClippingActiveDragPlanes: "面をドラッグして移動します。",
    ClippingInactiveTip: "有効化してドラッグ可能な面を表示します。",
    // Compass Widget and Zoom Controls translations
    CompassDragTooltip: "ドラッグして回転 • ダブルクリックでリセット",
    CompassJoystickTooltip: "ジョイスティックのようにドラッグ • 遠く = 高速 • 離すと停止",
    ZoomIn: "ズームイン",
    ZoomOut: "ズームアウト",
    TopView: "上面ビュー",
    BottomView: "下面ビュー",
    NorthView: "北ビュー",
    SouthView: "南ビュー",
    EastView: "東ビュー",
    WestView: "西ビュー",
    Rendering: "レンダリング",
    VisualFidelity: "描画品質",
    HighFidelity: "高品質",
    Balanced: "バランス",
    HighPerformance: "高速",
    ReducePixelDensity: "画素密度を低減する",
    RotateHint: "左ドラッグでこの円柱の位置を調整し、右ドラッグで向きを調整します。",
    IncreaseRadius: "増加",
    DecreaseRadius: "減少",
    Done: "終了",
    Track: "追跡",
    StopTracking: "追跡を停止する",
    // Status bar
    StatusBarNoTool: "ツールなし",
    StatusBarActiveTool: "アクティブツール",
    // Toolbar tooltip descriptions
    ToolbarMeasurementDesc: "距離・高さ・角度・面積",
    ToolbarProfilerDesc: "断面プロファイル",
    ToolbarClippingDesc: "平面で点群をクリップ",
    ToolbarGaussianDesc: "ガウシアンスプラッティング表示モード",
    ToolbarModelsDesc: "3Dモデルと製品",
    ToolbarViewpointsDesc: "カメラビューの保存と復元",
    ToolbarLayersDesc: "画像・地形・建物",
    ToolbarSettingsDesc: "点群とレンダリングの設定",
    TransformationTool: "変換",
    ToolbarTransformationDesc: "位置・回転・スケールの調整",
    SaveTransformation: "変換を保存",
    TransformationSaved: "変換を保存しました",
    TransformationSaveFailed: "変換の保存に失敗しました",
    RestoreDefault: "デフォルトに戻す",
    Translation: "平行移動",
    Rotation: "回転",
    Scale: "スケール",
    BothDatasets: "両方",
    Dataset: "データセット",
    // Toolbar groups
    ToolbarGroupAnalysis: "分析",
    ToolbarGroupVisualization: "可視化",
    ToolbarGroupSystem: "システム",
    // Panel pinning
    PinPanel: "パネルを固定",
    UnpinPanel: "パネルの固定を解除",
    // Color legend
    ShowLegend: "凡例を表示",
    HideLegend: "凡例を非表示",
    // Toast messages
    MeasurementExported: "測定値をエクスポートしました",
    NoMeasurementsToExport: "エクスポートする測定値がありません",
    MeasurementsImported: "測定値をインポートしました",
    MeasurementImportError: "測定値のインポートに失敗しました",
    ViewpointSaved: "ビューポイントを保存しました",
    ViewpointRestored: "ビューポイントを復元しました",
    ViewpointsExported: "ビューポイントをエクスポートしました",
    ViewpointsImported: "ビューポイントをインポートしました",
    Camera: "カメラ",
    Annotations: "注釈",
    PlaceAnnotation: "注釈を配置",
    ExportAnnotations: "注釈をエクスポート",
    ImportAnnotations: "注釈をインポート",
    ClearAllAnnotations: "すべての注釈をクリア",
    SavedAnnotations: "保存された注釈",
    AnnotationPlaced: "注釈を配置しました",
    AnnotationsExported: "注釈をエクスポートしました",
    AnnotationsImported: "注釈をインポートしました",
    ToolbarAnnotationsDesc: "テキストラベルを位置に固定",
    EnterAnnotationText: "注釈テキストを入力：",
    ClippingPlanesReset: "クリッピング面をリセットしました",
    Minimap: 'ミニマップ',
    ToggleMinimapDesc: '概要マップを切替',
    Close: '閉じる',
    // B4 – SSAO
    AmbientOcclusion: 'アンビエントオクルージョン',
    AmbientOcclusionIntensity: 'AO強度',
    FXAA: 'アンチエイリアシング (FXAA)',
    // A – Walk Mode
    WalkMode: 'ウォークモード',
    WalkModeHint: 'WASD で移動・ESC で終了',
    // Loading screen hints
    LoadingHint0: 'ビューワーを初期化中...',
    LoadingHint1: '地形を読み込み中...',
    LoadingHint2: 'データセットを読み込み中...',
    LoadingHint3: 'ポイントクラウドを準備中...',
    LoadingHint4: 'もうすぐ完了...',
    // Colormap palette switcher
    ColorScale: 'カラースケール',
    ColormapTurbo: 'ターボ',
    ColormapViridis: 'ビリディス',
    ColormapMagma: 'マグマ',
    ColormapInferno: 'インフェルノ',
    ColormapCividis: 'シビディス',
    ColormapGrayscale: 'グレースケール',
    // Coordinate format
    CoordFormatTooltip: 'クリックで形式を変更 (DD / DMS / UTM)',
    // Status bar / Statistics panel
    StatsTooltip: '統計',
    StatsPerformance: 'パフォーマンス',
    StatsPing: 'Ping',
    StatsTiles: 'タイル',
    StatsPending: '待機中',
    StatsProcessing: '処理中',
    StatsLoaded: '読込済',
    StatsRendered: '描画中',
    StatsFailed: '失敗',
    StatsData: 'データ',
    StatsPointsInTiles: '描画タイル内のポイント',
    StatsPointsInMemory: 'メモリ内のポイント',
    StatsGaussianSplats: 'ガウシアンスプラット',
    StatsTriangles: '三角形',
    StatsMemory: 'GPUメモリ',
    StatsTotal: '合計',
    StatsGeometry: 'ジオメトリ',
    StatsTextures: 'テクスチャ',
    StatsMetadata: 'メタデータ',
  },
};
